export default __webpack_public_path__ + "static/media/Versions - Differences - Design.07aa617c.png";